import React from 'react';
import classNames from 'classnames';
import WingBlank from '../WingBlank';
import Layer from '../Layer';
import './Layers.less';

const isGrey = (index, isStartGrey) => {
  return isStartGrey ? (index % 2) : !(index % 2);
};

function Layers({title, data, size, grey=false, className, children, ...props}) {
  const renderLayer = (data, index) => {
    return (
      <WingBlank key={index} data-mode={isGrey(index, grey) ? 'grey' : null}>
        {React.cloneElement(children, {data, index: index + 1})}
      </WingBlank>
    );
  };
  return (
    <div className={classNames('Layers', className)} {...props}>
      <Layer title={title} size={size} grey={grey}>
        {React.cloneElement(children, {data: data[0], index: 0})}
      </Layer>
      {data.slice(1).map(renderLayer)}
    </div>
  );
}

export default Layers;


// WEBPACK FOOTER //
// ./src/components/Layers/Layers.js